export default {
    description: {
        userMessageIntro: 'If you were attempting to find a user ',
        userMessage:
            'they have either changed their username or do not exist. Please check out the ',
        onlineModels: 'online models',
        pageOr: 'page. Or, ',
        search: 'search for them',
        searchMessageEnd: 'instead. ',
        intro: 'If you reached this page by error please ',
        contact: 'contact support',
        finish: 'and we will be happy to assist you.',
    },
}
